import { Location } from "@angular/common";
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { catchError, of, switchMap, withLatestFrom } from "rxjs";
import { ResultService } from "../../services/result/result.service";
import { appEventActions } from "../app-event";
import { resultActions } from "./result.action";
import { selectResultsCache } from "./result.reducer";
import { lovsActions } from "../lovs";

@Injectable()
export class ResultEffects {
    constructor(
        private actions$: Actions,
        private resultService: ResultService,
        private _location: Location,
        private store: Store,
    ) {}

    create$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(resultActions.create),
            switchMap((data) =>
                this.resultService.create(data.data).pipe(
                    switchMap((resp) => {
                        this._location.back();
                        return of(
                            appEventActions.addToast({
                                severity: "success",
                                detail: "Results uploaded successfully.",
                            }),
                        );
                    }),
                    catchError((err) => {
                        return of(appEventActions.handleError(err));
                    }),
                ),
            ),
        );
    });

    preview$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(resultActions.preview),
            switchMap((data) =>
                this.resultService.preview(data.data).pipe(
                    switchMap((resp) => {
                        return of(resultActions.setResultPreview({ data: resp }));
                    }),
                    catchError((err) => {
                        return of(appEventActions.handleError(err));
                    }),
                ),
            ),
        );
    });

    generateUploadUrl$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(resultActions.generateUploadUrl),
            switchMap((data) =>
                this.resultService.generateUploadUrl(data.data).pipe(
                    switchMap((resp) => {
                        return of(resultActions.setUploadUrlData({ data: resp?.responses }));
                    }),
                    catchError((err) => {
                        return of(appEventActions.handleError(err));
                    }),
                ),
            ),
        );
    });

    confirmResultUpload$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(resultActions.confirmResultUpload),
            switchMap((data) =>
                this.resultService.confirmResultUpload(data.data).pipe(
                    switchMap((resp) => {
                        this._location.back();
                        return of(
                            appEventActions.addToast({
                                severity: "success",
                                detail: "Results uploaded successfully.",
                            }),
                        );
                        // return of(resultActions.setUploadUrlData({ data: resp }));
                    }),
                    catchError((err) => {
                        return of(appEventActions.handleError(err));
                    }),
                ),
            ),
        );
    });

    getResult$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(resultActions.getResult),
            withLatestFrom(this.store.select(selectResultsCache)),
            switchMap(([data, cache]) =>
                !cache[data.id] || data.replace
                    ? this.resultService.getResult(data.id).pipe(
                        switchMap((data) => {
                            return of(resultActions.setResult({ data }));
                        }),
                        catchError((err) => {
                            return of(appEventActions.handleError(err));
                        }),
                    )
                    : of(resultActions.setResult({ data: cache[data.id] })),
            ),
        );
    });

    downloadResult$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(resultActions.downloadResult),
            switchMap((data) =>
                this.resultService.downloadResult(data.data).pipe(
                    switchMap((resp) => {
                        console.log(resp, "<=respppp");
                        const url = resp.download_url;

                        if (data?.is_download) {
                            fetch(url)
                                .then((response) => response.blob())
                                .then((blob) => {
                                    const blobUrl = window.URL.createObjectURL(blob);
                                    const a = document.createElement("a");
                                    a.href = blobUrl;

                                    // ✅ Extract filename from URL dynamically
                                    const urlParts = url.split("/");
                                    const filename = urlParts[urlParts.length - 1].split("?")[0];
                                    a.download = filename || "file.pdf"; // forces "Save As" dialog

                                    document.body.appendChild(a);
                                    a.click();
                                    a.remove();
                                    window.URL.revokeObjectURL(blobUrl);
                                })
                                .catch((error) => console.error("Download failed:", error));
                        } else {
                            window.open(url, "_blank");
                        }

                        return of(appEventActions.emptyAction());
                        // return of(resultActions.setUploadUrlData({ data: resp }));
                    }),
                    catchError((err) => {
                        return of(appEventActions.handleError(err));
                    }),
                ),
            ),
        );
    });

    deleteResult$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(resultActions.deleteResult),
            switchMap((data) =>
                this.resultService.deleteResult(data.id).pipe(
                    switchMap(() => {
                        return of(
                            lovsActions.getLovData({ data: { url: '/app/results/classroom/' + data.classroomExamId + '/', skipCache: true } }),
                            appEventActions.addToast({
                                severity: "success",
                                detail: "Result deleted successfully.",
                            }));
                    }),
                    catchError((err) => {
                        return of(appEventActions.handleError(err));
                    }),
                ),
            ),
        );
    });
}
